import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {SystemEntity} from './system.entity';
import {AccountEntity} from "./account.entity";

@EntityTable('account_settings', '5777788c-0876-465c-8fc9-21b9683c305e')
export class AccountSettingsEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, AccountEntity, false, false, FieldRelationKind.BELONGS_TO, 'account')
    public accountId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Column(FieldTypeKind.ANY)
    public config: any;
}
